import { z } from 'zod';
/** Client → server realtime events. Every event is authorised server-side (ADR-009). */
export const ClientEvent = z.discriminatedUnion('t', [
    z.object({
        t: z.literal('room.subscribe'),
        roomId: z.string().uuid(),
        afterSeq: z.number().int().min(0).optional(),
    }),
    z.object({ t: z.literal('room.unsubscribe'), roomId: z.string().uuid() }),
    z.object({ t: z.literal('typing'), roomId: z.string().uuid() }),
    z.object({ t: z.literal('presence.join'), projectId: z.string().uuid() }),
    z.object({ t: z.literal('presence.leave'), projectId: z.string().uuid() }),
    z.object({
        t: z.literal('team.send'),
        projectId: z.string().uuid(),
        text: z.string().min(1).max(2000),
        tempId: z.string().min(1).max(64),
    }),
    /** "Titreşim" (nudge): ask an online teammate to come to a room. Ephemeral, never stored. */
    z.object({
        t: z.literal('nudge.send'),
        projectId: z.string().uuid(),
        roomId: z.string().uuid(),
        toUserId: z.string().uuid(),
    }),
    z.object({ t: z.literal('ping') }),
]);
/** Initial policy values (ADR-004); not yet measured on real devices. */
export const REALTIME_POLICY = {
    heartbeatMs: 15_000,
    presenceReconnectingAfterMs: 30_000,
    presenceDropAfterMs: 45_000,
    teamMaxChars: 2000,
    teamRateWindowMs: 10_000,
    teamRateMax: 10,
    teamClientMaxMessages: 200,
    /** Team Chat lines disappear from every screen 30 s after they arrive (user decision 2026-10-07). */
    teamClientTtlMs: 30_000,
    maxBufferedBytes: 1_000_000,
    /** One nudge per sender → recipient in this window. */
    nudgeCooldownMs: 20_000,
    /** Team Chat files/photos: max size, server memory lifetime and limits (never written to disk). */
    teamDropMaxBytes: 10 * 1024 * 1024,
    teamDropTtlMs: 60_000,
    teamDropRateWindowMs: 60_000,
    teamDropRateMax: 8,
    teamDropMemoryBytes: 120 * 1024 * 1024,
};
/** Executable / active-content extensions refused in Team Chat (and never rendered). */
export const TEAM_DROP_BLOCKED_EXT = [
    'exe',
    'msi',
    'bat',
    'cmd',
    'com',
    'scr',
    'pif',
    'cpl',
    'vbs',
    'vbe',
    'js',
    'jse',
    'wsf',
    'wsh',
    'ps1',
    'psm1',
    'sh',
    'bash',
    'zsh',
    'app',
    'dmg',
    'pkg',
    'apk',
    'jar',
    'html',
    'htm',
    'xhtml',
    'svg',
    'svgz',
    'hta',
    'lnk',
    'reg',
    'dll',
    'so',
    'dylib',
    'iso',
    'img',
];
//# sourceMappingURL=realtime.js.map